// src/components/ui/CustomCursor.jsx
import { useEffect, useRef } from "react";
import gsap from "gsap";
import useCursorStore from "../store/cursorStore";

export default function CustomCursor() {
  const cursorRef = useRef();
  const setCursorElement = useCursorStore((s) => s.setCursorElement);

  useEffect(() => {
    const cursor = cursorRef.current;
    setCursorElement(cursor);

    // Appliquer thème initial
    cursor.classList.add("cursor-light"); // par défaut

    const onMove = (e) => {
        gsap.to(cursor, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.2,
        ease: "power3.out",
        });
    };

    window.addEventListener("pointermove", onMove);
    return () => {
        window.removeEventListener("pointermove", onMove);
    };
    }, [setCursorElement]);


  return (
    <div className="custom-cursor-wrapper">
      <svg
        ref={cursorRef}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        style={{ position: "absolute", top: 0, left: 0, pointerEvents: "none" }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.727273"
          y="0.727273"
          width="14.5455"
          height="14.5455"
          rx="7.27273"
          fill="white"
          fillOpacity="0.4"
        />
        <rect
          x="0.727273"
          y="0.727273"
          width="14.5455"
          height="14.5455"
          rx="7.27273"
          stroke="white"
          strokeWidth="1.45455"
        />
      </svg>
    </div>
  );
}
